const CACHE_VERSION_STORAGE_KEY = 'devsuiteCacheVersion'

export function removeCacheVersion(): void {
  localStorage.removeItem(CACHE_VERSION_STORAGE_KEY)
}

export function getCacheVersion(): string {
  try {
    const value = localStorage.getItem(CACHE_VERSION_STORAGE_KEY)
    return value ?? ''
  } catch {
    return ''
  }
}

export function setCacheVersion(version: string): void {
  localStorage.setItem(CACHE_VERSION_STORAGE_KEY, version)
}
